import {
  PROFORMA_INVOICE_LIST,
  PROFORMA_INVOICE_LIST_SUCCESS,
  PROFORMA_INVOICE_LIST_FAILURE,
  PROFORMA_INVOICE_LIST_SEARCH,
  PROFORMA_INVOICE_LIST_SEARCH_SUCCESS,
  PROFORMA_INVOICE_LIST_SEARCH_FAILURE,
  PROFORMA_INVOICE_DATA,
  PROFORMA_INVOICE_DATA_SUCCESS,
  PROFORMA_INVOICE_DATA_FAILURE,
  PROFORMA_INVOICE_CREATE,
  PROFORMA_INVOICE_CREATE_SUCCESS,
  PROFORMA_INVOICE_CREATE_FAILURE,
  PROFORMA_INVOICE_UPDATE,
  PROFORMA_INVOICE_UPDATE_SUCCESS,
  PROFORMA_INVOICE_UPDATE_FAILURE,
  PROFORMA_INVOICE_VOID,
  PROFORMA_INVOICE_VOID_SUCCESS,
  PROFORMA_INVOICE_VOID_FAILURE,
  PROFORMA_INVOICE_ITEM_SEARCH,
  PROFORMA_INVOICE_ITEM_SEARCH_SUCCESS,
  PROFORMA_INVOICE_ITEM_SEARCH_FAILURE,
  PROFORMA_INVOICE_ITEM_LIST,
  PROFORMA_INVOICE_ITEM_LIST_SUCCESS,
  PROFORMA_INVOICE_ITEM_LIST_FAILURE,
  PROFORMA_INVOICE_STATUS_LIST,
  PROFORMA_INVOICE_STATUS_LIST_SUCCESS,
  PROFORMA_INVOICE_STATUS_LIST_FAILURE,
  PROFORMA_INVOICE_STATUS_DATA,
  PROFORMA_INVOICE_STATUS_DATA_SUCCESS,
  PROFORMA_INVOICE_STATUS_DATA_FAILURE,
  PROFORMA_INVOICE_STATUS_CREATE,
  PROFORMA_INVOICE_STATUS_CREATE_SUCCESS,
  PROFORMA_INVOICE_STATUS_CREATE_FAILURE,
  PROFORMA_INVOICE_STATUS_UPDATE,
  PROFORMA_INVOICE_STATUS_UPDATE_SUCCESS,
  PROFORMA_INVOICE_STATUS_UPDATE_FAILURE,
  PROFORMA_INVOICE_STATUS_DELETE,
  PROFORMA_INVOICE_STATUS_DELETE_SUCCESS,
  PROFORMA_INVOICE_STATUS_DELETE_FAILURE,
  PROFORMA_INVOICE_PDF,
  PROFORMA_INVOICE_PDF_SUCCESS,
  PROFORMA_INVOICE_PDF_FAILURE,
  PROFORMA_INVOICE_EMAIL_SEND_AUTOMATED,
  PROFORMA_INVOICE_EMAIL_SEND_AUTOMATED_SUCCESS,
  PROFORMA_INVOICE_EMAIL_SEND_AUTOMATED_FAILURE,
  PROFORMA_INVOICE_EMAIL_RESEND_AUTOMATED,
  PROFORMA_INVOICE_EMAIL_RESEND_AUTOMATED_SUCCESS,
  PROFORMA_INVOICE_EMAIL_RESEND_AUTOMATED_FAILURE,
  PROFORMA_INVOICE_CONVERT_TO_INVOICE,
  PROFORMA_INVOICE_CONVERT_TO_INVOICE_SUCCESS,
  PROFORMA_INVOICE_CONVERT_TO_INVOICE_FAILURE,
  PROFORMA_INVOICE_SEARCH,
  PROFORMA_INVOICE_SEARCH_SUCCESS,
  PROFORMA_INVOICE_SEARCH_FAILURE,
  PROFORMA_INVOICE_ACTIVITY_LOG_SEARCH,
  PROFORMA_INVOICE_ACTIVITY_LOG_SEARCH_SUCCESS,
  PROFORMA_INVOICE_ACTIVITY_LOG_SEARCH_FAILURE,
} from "./actionType";

const initialData = {
  invoiceListData: [],
  invoiceListDataError: "",
  invoiceListDataLoading: false,

  invoiceListSearchData: [],
  invoiceListSearchDataError: "",
  invoiceListSearchDataLoading: false,

  invoiceData: [],
  invoiceDataError: "",
  invoiceDataLoading: false,

  invoiceCreateData: [],
  invoiceCreateDataError: "",
  invoiceCreateDataLoading: false,

  invoiceUpdateData: [],
  invoiceUpdateDataError: "",
  invoiceUpdateDataLoading: false,

  invoiceVoidData: [],
  invoiceVoidDataError: "",
  invoiceVoidDataLoading: false,

  invoiceItemSearchData: [],
  invoiceItemSearchDataError: "",
  invoiceItemSearchDataLoading: false,

  invoiceItemListData: [],
  invoiceItemListDataError: "",
  invoiceItemListDataLoading: false,

  invoiceStatusListData: [],
  invoiceStatusListDataError: "",
  invoiceStatusListDataLoading: false,

  invoiceStatusData: [],
  invoiceStatusDataError: "",
  invoiceStatusDataLoading: false,

  invoiceStatusCreateData: [],
  invoiceStatusCreateDataError: "",
  invoiceStatusCreateDataLoading: false,

  invoiceStatusUpdateData: [],
  invoiceStatusUpdateDataError: "",
  invoiceStatusUpdateDataLoading: false,

  invoiceStatusDeleteData: [],
  invoiceStatusDeleteDataError: "",
  invoiceStatusDeleteDataLoading: false,

  invoicePdfData: [],
  invoicePdfDataError: "",
  invoicePdfDataLoading: false,

  invoiceEmailSendAutomatedData: [],
  invoiceEmailSendAutomatedDataError: "",
  invoiceEmailSendAutomatedDataLoading: false,

  invoiceEmailResendAutomatedData: [],
  invoiceEmailResendAutomatedDataError: "",
  invoiceEmailResendAutomatedDataLoading: false,

  invoiceConvertToInvoiceData: [],
  invoiceConvertToInvoiceDataError: "",
  invoiceConvertToInvoiceDataLoading: false,

  invoiceSearchData: [],
  invoiceSearchDataError: "",
  invoiceSearchDataLoading: false,

  invoiceActivityLogSearchData: [],
  invoiceActivityLogSearchDataError: "",
  invoiceActivityLogSearchDataLoading: false,
};

const ProformaInvoice = (state = initialData, action) => {
  switch (action.type) {
    case PROFORMA_INVOICE_LIST:
      return {
        ...state,
        invoiceListData: [],
        invoiceListDataError: "",
        invoiceListDataLoading: true,
      };
    case PROFORMA_INVOICE_LIST_SUCCESS:
      return {
        ...state,
        invoiceListData: action.payload,
        invoiceListDataError: "",
        invoiceListDataLoading: false,
      };
    case PROFORMA_INVOICE_LIST_FAILURE:
      return {
        ...state,
        invoiceListData: [],
        invoiceListDataError: action.error,
        invoiceListDataLoading: false,
      };

    case PROFORMA_INVOICE_LIST_SEARCH:
      return {
        ...state,
        invoiceListSearchData: [],
        invoiceListSearchDataError: "",
        invoiceListSearchDataLoading: true,
      };
    case PROFORMA_INVOICE_LIST_SEARCH_SUCCESS:
      return {
        ...state,
        invoiceListSearchData: action.payload,
        invoiceListSearchDataError: "",
        invoiceListSearchDataLoading: false,
      };
    case PROFORMA_INVOICE_LIST_SEARCH_FAILURE:
      return {
        ...state,
        invoiceListSearchData: [],
        invoiceListSearchDataError: action.payload,
        invoiceListSearchDataLoading: false,
      };

    case PROFORMA_INVOICE_DATA:
      return {
        ...state,
        invoiceData: [],
        invoiceDataError: "",
        invoiceDataLoading: true,
      };
    case PROFORMA_INVOICE_DATA_SUCCESS:
      return {
        ...state,
        invoiceData: action.payload,
        invoiceDataError: "",
        invoiceDataLoading: false,
      };
    case PROFORMA_INVOICE_DATA_FAILURE:
      return {
        ...state,
        invoiceData: [],
        invoiceDataError: action.error,
        invoiceDataLoading: false,
      };

    case PROFORMA_INVOICE_CREATE:
      return {
        ...state,
        invoiceCreateData: [],
        invoiceCreateDataError: "",
        invoiceCreateDataLoading: true,
      };
    case PROFORMA_INVOICE_CREATE_SUCCESS:
      return {
        ...state,
        invoiceCreateData: action.payload,
        invoiceCreateDataError: "",
        invoiceCreateDataLoading: false,
      };
    case PROFORMA_INVOICE_CREATE_FAILURE:
      return {
        ...state,
        invoiceCreateData: [],
        invoiceCreateDataError: action.error,
        invoiceCreateDataLoading: false,
      };

    case PROFORMA_INVOICE_UPDATE:
      return {
        ...state,
        invoiceUpdateData: [],
        invoiceUpdateDataError: "",
        invoiceUpdateDataLoading: true,
      };
    case PROFORMA_INVOICE_UPDATE_SUCCESS:
      return {
        ...state,
        invoiceUpdateData: action.payload,
        invoiceUpdateDataError: "",
        invoiceUpdateDataLoading: false,
      };
    case PROFORMA_INVOICE_UPDATE_FAILURE:
      return {
        ...state,
        invoiceUpdateData: [],
        invoiceUpdateDataError: action.error,
        invoiceUpdateDataLoading: false,
      };

    case PROFORMA_INVOICE_VOID:
      return {
        ...state,
        invoiceVoidData: [],
        invoiceVoidDataError: "",
        invoiceVoidDataLoading: true,
      };
    case PROFORMA_INVOICE_VOID_SUCCESS:
      return {
        ...state,
        invoiceVoidData: action.payload,
        invoiceVoidDataError: "",
        invoiceVoidDataLoading: false,
      };
    case PROFORMA_INVOICE_VOID_FAILURE:
      return {
        ...state,
        invoiceVoidData: [],
        invoiceVoidDataError: action.error,
        invoiceVoidDataLoading: false,
      };

    case PROFORMA_INVOICE_ITEM_SEARCH:
      return {
        ...state,
        invoiceItemSearchData: [],
        invoiceItemSearchDataError: "",
        invoiceItemSearchDataLoading: true,
      };
    case PROFORMA_INVOICE_ITEM_SEARCH_SUCCESS:
      return {
        ...state,
        invoiceItemSearchData: action.payload,
        invoiceItemSearchDataError: "",
        invoiceItemSearchDataLoading: false,
      };
    case PROFORMA_INVOICE_ITEM_SEARCH_FAILURE:
      return {
        ...state,
        invoiceItemSearchData: [],
        invoiceItemSearchDataError: action.error,
        invoiceItemSearchDataLoading: false,
      };

    case PROFORMA_INVOICE_ITEM_LIST:
      return {
        ...state,
        invoiceItemListData: [],
        invoiceItemListDataError: "",
        invoiceItemListDataLoading: true,
      };
    case PROFORMA_INVOICE_ITEM_LIST_SUCCESS:
      return {
        ...state,
        invoiceItemListData: action.payload,
        invoiceItemListDataError: "",
        invoiceItemListDataLoading: false,
      };
    case PROFORMA_INVOICE_ITEM_LIST_FAILURE:
      return {
        ...state,
        invoiceItemListData: [],
        invoiceItemListDataError: action.error,
        invoiceItemListDataLoading: false,
      };

    case PROFORMA_INVOICE_STATUS_LIST:
      return {
        ...state,
        invoiceStatusListData: [],
        invoiceStatusListDataError: "",
        invoiceStatusListDataLoading: true,
      };
    case PROFORMA_INVOICE_STATUS_LIST_SUCCESS:
      return {
        ...state,
        invoiceStatusListData: action.payload,
        invoiceStatusListDataError: "",
        invoiceStatusListDataLoading: false,
      };
    case PROFORMA_INVOICE_STATUS_LIST_FAILURE:
      return {
        ...state,
        invoiceStatusListData: [],
        invoiceStatusListDataError: action.error,
        invoiceStatusListDataLoading: false,
      };

    case PROFORMA_INVOICE_STATUS_DATA:
      return {
        ...state,
        invoiceStatusData: [],
        invoiceStatusDataError: "",
        invoiceStatusDataLoading: true,
      };
    case PROFORMA_INVOICE_STATUS_DATA_SUCCESS:
      return {
        ...state,
        invoiceStatusData: action.payload,
        invoiceStatusDataError: "",
        invoiceStatusDataLoading: false,
      };
    case PROFORMA_INVOICE_STATUS_DATA_FAILURE:
      return {
        ...state,
        invoiceStatusData: [],
        invoiceStatusDataError: action.error,
        invoiceStatusDataLoading: false,
      };

    case PROFORMA_INVOICE_STATUS_CREATE:
      return {
        ...state,
        invoiceStatusCreateData: [],
        invoiceStatusCreateDataError: "",
        invoiceStatusCreateDataLoading: true,
      };
    case PROFORMA_INVOICE_STATUS_CREATE_SUCCESS:
      return {
        ...state,
        invoiceStatusCreateData: action.payload,
        invoiceStatusCreateDataError: "",
        invoiceStatusCreateDataLoading: false,
      };
    case PROFORMA_INVOICE_STATUS_CREATE_FAILURE:
      return {
        ...state,
        invoiceStatusCreateData: [],
        invoiceStatusCreateDataError: action.error,
        invoiceStatusCreateDataLoading: false,
      };

    case PROFORMA_INVOICE_STATUS_UPDATE:
      return {
        ...state,
        invoiceStatusUpdateData: [],
        invoiceStatusUpdateDataError: "",
        invoiceStatusUpdateDataLoading: true,
      };
    case PROFORMA_INVOICE_STATUS_UPDATE_SUCCESS:
      return {
        ...state,
        invoiceStatusUpdateData: action.payload,
        invoiceStatusUpdateDataError: "",
        invoiceStatusUpdateDataLoading: false,
      };
    case PROFORMA_INVOICE_STATUS_UPDATE_FAILURE:
      return {
        ...state,
        invoiceStatusUpdateData: [],
        invoiceStatusUpdateDataError: action.error,
        invoiceStatusUpdateDataLoading: false,
      };

    case PROFORMA_INVOICE_STATUS_DELETE:
      return {
        ...state,
        invoiceStatusDeleteData: [],
        invoiceStatusDeleteDataError: "",
        invoiceStatusDeleteDataLoading: true,
      };
    case PROFORMA_INVOICE_STATUS_DELETE_SUCCESS:
      return {
        ...state,
        invoiceStatusDeleteData: action.payload,
        invoiceStatusDeleteDataError: "",
        invoiceStatusDeleteDataLoading: false,
      };
    case PROFORMA_INVOICE_STATUS_DELETE_FAILURE:
      return {
        ...state,
        invoiceStatusDeleteData: [],
        invoiceStatusDeleteDataError: action.error,
        invoiceStatusDeleteDataLoading: false,
      };
    case PROFORMA_INVOICE_PDF:
      return {
        ...state,
        invoicePdfData: [],
        invoicePdfDataError: "",
        invoicePdfDataLoading: true,
      };
    case PROFORMA_INVOICE_PDF_SUCCESS:
      return {
        ...state,
        invoicePdfData: action.payload,
        invoicePdfDataError: "",
        invoicePdfDataLoading: false,
      };
    case PROFORMA_INVOICE_PDF_FAILURE:
      return {
        ...state,
        invoicePdfData: [],
        invoicePdfDataError: action.error,
        invoicePdfDataLoading: false,
      };
    case PROFORMA_INVOICE_EMAIL_SEND_AUTOMATED:
      return {
        ...state,
        invoiceEmailSendAutomatedData: [],
        invoiceEmailSendAutomatedDataError: "",
        invoiceEmailSendAutomatedDataLoading: true,
      };
    case PROFORMA_INVOICE_EMAIL_SEND_AUTOMATED_SUCCESS:
      return {
        ...state,
        invoiceEmailSendAutomatedData: action.payload,
        invoiceEmailSendAutomatedDataError: "",
        invoiceEmailSendAutomatedDataLoading: false,
      };
    case PROFORMA_INVOICE_EMAIL_SEND_AUTOMATED_FAILURE:
      return {
        ...state,
        invoiceEmailSendAutomatedData: [],
        invoiceEmailSendAutomatedDataError: action.error,
        invoiceEmailSendAutomatedDataLoading: false,
      };
    case PROFORMA_INVOICE_EMAIL_RESEND_AUTOMATED:
      return {
        ...state,
        invoiceEmailResendAutomatedData: [],
        invoiceEmailResendAutomatedDataError: "",
        invoiceEmailResendAutomatedDataLoading: true,
      };
    case PROFORMA_INVOICE_EMAIL_RESEND_AUTOMATED_SUCCESS:
      return {
        ...state,
        invoiceEmailResendAutomatedData: action.payload,
        invoiceEmailResendAutomatedDataError: "",
        invoiceEmailResendAutomatedDataLoading: false,
      };
    case PROFORMA_INVOICE_EMAIL_RESEND_AUTOMATED_FAILURE:
      return {
        ...state,
        invoiceEmailResendAutomatedData: [],
        invoiceEmailResendAutomatedDataError: action.error,
        invoiceEmailResendAutomatedDataLoading: false,
      };
    case PROFORMA_INVOICE_CONVERT_TO_INVOICE:
      return {
        ...state,
        invoiceConvertToInvoiceData: [],
        invoiceConvertToInvoiceDataError: "",
        invoiceConvertToInvoiceDataLoading: true,
      };
    case PROFORMA_INVOICE_CONVERT_TO_INVOICE_SUCCESS:
      return {
        ...state,
        invoiceConvertToInvoiceData: action.payload,
        invoiceConvertToInvoiceDataError: "",
        invoiceConvertToInvoiceDataLoading: false,
      };
    case PROFORMA_INVOICE_CONVERT_TO_INVOICE_FAILURE:
      return {
        ...state,
        invoiceConvertToInvoiceData: [],
        invoiceConvertToInvoiceDataError: action.error,
        invoiceConvertToInvoiceDataLoading: false,
      };
    case PROFORMA_INVOICE_SEARCH:
      return {
        ...state,
        invoiceSearchData: [],
        invoiceSearchDataError: "",
        invoiceSearchDataLoading: true,
      };
    case PROFORMA_INVOICE_SEARCH_SUCCESS:
      return {
        ...state,
        invoiceSearchData: action.payload,
        invoiceSearchDataError: "",
        invoiceSearchDataLoading: false,
      };
    case PROFORMA_INVOICE_SEARCH_FAILURE:
      return {
        ...state,
        invoiceSearchData: [],
        invoiceSearchDataError: action.error,
        invoiceSearchDataLoading: false,
      };
    case PROFORMA_INVOICE_ACTIVITY_LOG_SEARCH:
      return {
        ...state,
        invoiceActivityLogSearchData: [],
        invoiceActivityLogSearchDataError: "",
        invoiceActivityLogSearchDataLoading: true,
      };
    case PROFORMA_INVOICE_ACTIVITY_LOG_SEARCH_SUCCESS:
      return {
        ...state,
        invoiceActivityLogSearchData: action.payload,
        invoiceActivityLogSearchDataError: "",
        invoiceActivityLogSearchDataLoading: false,
      };
    case PROFORMA_INVOICE_ACTIVITY_LOG_SEARCH_FAILURE:
      return {
        ...state,
        invoiceActivityLogSearchData: [],
        invoiceActivityLogSearchDataError: action.error,
        invoiceActivityLogSearchDataLoading: false,
      };

    default:
      return state;
  }
};

export default ProformaInvoice;
